import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { TagsComponent } from './tags.component';
import { TagListTableComponent } from './partials/tag-list-table.component';
import { TagService } from './tag.service';

@NgModule({
  declarations: [TagsComponent, TagListTableComponent],
  imports: [HttpClientModule, CommonModule, InfiniteScrollModule],
  providers: [TagService],
  entryComponents: [TagsComponent],
})
export class TagsModule {}



// WEBPACK FOOTER //
// ./src/app/tags/tags.module.ts